/**
 * Light Theme Configuration
 *
 * Ant Design theme configuration for light mode
 */

import type { ThemeConfig } from 'antd';
import { colors, borderRadius } from './tokens';

export const lightTheme: ThemeConfig = {
  token: {
    // Brand colors
    colorPrimary: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.error,
    colorInfo: colors.info,

    // Background colors
    colorBgBase: colors.light.bg,
    colorBgContainer: colors.light.bg,
    colorBgElevated: colors.light.bg,
    colorBgLayout: colors.light.bgLayout,
    colorBgSpotlight: colors.light.bgSecondary,

    // Text colors
    colorText: colors.light.text,
    colorTextSecondary: colors.light.textSecondary,
    colorTextTertiary: colors.light.textTertiary,
    colorTextQuaternary: colors.light.textDisabled,

    // Border colors
    colorBorder: colors.light.border,
    colorBorderSecondary: colors.light.borderSecondary,

    // Border radius
    borderRadius: borderRadius.base,
    borderRadiusLG: borderRadius.md,
    borderRadiusSM: borderRadius.sm,

    // Font
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,

    // Spacing
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,

    // Control sizes
    controlHeight: 32,
    controlHeightLG: 40,
    controlHeightSM: 24,

    // Shadows
    boxShadow: `0 2px 8px ${colors.light.shadow}`,
    boxShadowSecondary: `0 4px 12px ${colors.light.shadowMedium}`,
  },

  components: {
    Layout: {
      headerBg: colors.light.bg,
      headerColor: colors.light.text,
      bodyBg: colors.light.bgLayout,
      siderBg: '#001529', // Dark sidebar in light mode (common pattern)
    },

    Menu: {
      darkItemBg: '#001529',
      darkItemColor: colors.light.textSecondary,
      darkItemHoverBg: '#1f1f1f',
      darkItemSelectedBg: colors.primary,
      darkItemSelectedColor: '#ffffff',
    },

    Card: {
      colorBgContainer: colors.light.bg,
      boxShadow: `0 1px 2px ${colors.light.shadow}`,
    },

    Table: {
      headerBg: colors.light.bgSecondary,
      headerColor: colors.light.text,
      rowHoverBg: colors.light.hover,
    },

    Button: {
      primaryShadow: `0 2px 0 ${colors.light.shadow}`,
    },

    Drawer: {
      colorBgElevated: colors.light.bg,
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
    },

    Modal: {
      contentBg: colors.light.bg,
      headerBg: colors.light.bg,
    },
  },

  algorithm: undefined, // Use default light algorithm
};
